import { render } from "./widget-indicator-offline.vue?vue&type=template&id=294126ed&ts=true"
import script from "./widget-indicator-offline.ts?vue&type=script&lang=ts"
export * from "./widget-indicator-offline.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__